import React, { useEffect } from "react";
//import Footer from "./ui/footer/footer";
//import MiddleHeader from "./ui/headers/middleHeader";
//import Searchbar from "./includes/Searchbar";
//import TopNavbar from "./ui/countdown/topNavbar/topNavbar";
//import Searchfield from "./ui/searchfield/Searchfield";

function Imprint() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="page-wrapper">
      {/*<header className="header">
        <TopNavbar />
        <MiddleHeader />
        <Searchbar />
        <Searchfield />
      </header> */}

      <div className="container">
        <h2
          className="title tab-pane-title font-weight-bold mb-2"
          style={{ fontSize: "3rem", marginTop: "2rem" }}
        >
          Impressum Angaben gemäß § 5 TMG
        </h2>

        <h4 className="title tab-pane-title font-weight-bold mb-2">Kontakt</h4>
        <p className="mb-4">
          www.bestpreispyro.de ist ein Angebot von helpaholiCom UG
          (haftungsbeschränkt)
          <br />
          <strong>helpaholiCom UG (haftungsbeschränkt)</strong>
          <br />
          Gewerbepark 2 92526 Oberviechtach Deutschland
          <br />
          Telefon: +49 9671 8474045 (kein Kundenservice)
          <br />
          E-Mail: mail@bestpreispyro.de
          <br />
          Geschäftsführer: Stefan Schiller
          <br />
          Verantwortlich gemäß § 18 MStV: Stefan Schiller Gewerbepark 2 92526
          Oberviechtach Deutschland
        </p>

        <h4 className="title tab-pane-title font-weight-bold mb-2">
          Streitschlichtung
        </h4>
        <p className="mb-4">
          Die Europäische Kommission stellt eine Plattform zur
          Online-Streitbeilegung bereit: https://ec.europa.eu/consumers/odr/.
          Unsere E-Mail-Adresse finden Sie oben im Impressum. Wir sind nicht
          bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
          Verbraucherschlichtungsstelle teilzunehmen.
        </p>
        <h4 className="title tab-pane-title font-weight-bold mb-2">
          Haftung für Inhalte
        </h4>
        <p className="mb-4">
          Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte
          auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach
          §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht
          verpflichtet, übermittelte oder gespeicherte fremde Informationen zu
          überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige
          Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der
          Nutzung von Informationen nach den allgemeinen Gesetzen bleiben
          hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem
          Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei
          Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese
          Inhalte umgehend entfernen.
        </p>
        <h4 className="title tab-pane-title font-weight-bold mb-2">
          Haftung für Links
        </h4>
        <p className="mb-4">
          Unser Angebot enthält Links zu externen Websites Dritter, auf deren
          Inhalte wir keinen Einfluss haben. Deshalb können wir für diese
          fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der
          verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der
          Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der
          Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige
          Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine
          permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne
          konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei
          Bekanntwerden von Rechtsverletzungen werden wir derartige Links
          umgehend entfernen.
        </p>
        <h4 className="title tab-pane-title font-weight-bold mb-2">
          Urheberrecht
        </h4>
        <p className="mb-4">
          Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen
          Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung,
          Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
          Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des
          jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite
          sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
          Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt
          wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden
          Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf
          eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen
          entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen
          werden wir derartige Inhalte umgehend entfernen.
        </p>
      </div>
      {/*<Footer /> */}
    </div>
  );
}

export default Imprint;
